import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { Empty_LetterRequestCustomer_Order_Interface, LetterRequestCustomer_Order_Interface } from 'src/app/Interface/LetterRequestCustomer_Order_Interface';
import { Empty_Letter_Interface, Letter_Interface } from 'src/app/Interface/Letter_Interface';

import { Tariff_Interface, Empty_Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DevicepersianService } from 'src/app/Service/Devicepersian/Devicepersian.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LoginService } from 'src/app/Service/Login/Login.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';
import { environment } from 'src/environments/environment';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';

@Component({
  selector: 'app-LetterRequestCustomerCalibration',
  templateUrl: './LetterRequestCustomerCalibration.component.html',
  styleUrls: ['./LetterRequestCustomerCalibration.component.scss']
})
export class LetterRequestCustomerCalibrationComponent implements OnInit {

  Token: string = ""
  typeUser: any
  Letter_Form_Id: any
  parentRefer: number = 0
  canEditMainForm: boolean

  Record_Letter: Letter_Interface=Empty_Letter_Interface()

  constructor(
    private Customer_Service: CustomerService,
    private modalService: BsModalService,
    private Nav_Service: NavService,
    private Tariff_Service: TariffService,
    private Device_Service: DeviceService,
    private Devicepersian_Service: DevicepersianService,
    private route: ActivatedRoute,
    private Expiration_Service: ExpirationService,
    private login_Service: LoginService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private Price_Service: PriceService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Letter_Form_Id = this.route.snapshot.paramMap.get('id')

    this.login_Service.GetUserRole(this.Token).subscribe(
      data => {
        this.typeUser = data['type']

        if (this.typeUser == 3 || this.typeUser == 4) {
          this.Data_Seleted_Customer.id = data['customerId']
          this.Data_Seleted_Customer.code = data['customerCode']
          this.Data_Seleted_Customer.name = data['customerName']

          this.Nav_Service.CheckValidPage(this.Token, 1109).subscribe(
            data => {
              if (this.Letter_Form_Id) {
                this.OnInitail_Form();
              }
              else {
                this.Read_Order_Operation()
              }
            }
            , error => {
              localStorage.clear()
              location.reload();
            }
          )


        }
        else if ((this.typeUser == 1 || this.typeUser == 2) && this.Letter_Form_Id) {
          this.OnInitail_Form();
        }
        else {
          localStorage.clear()
          location.reload();
        }

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )

    this.AddNewLetter = new FormGroup({

      giver_name: new FormControl(null, Validators.required),
      giver_semat: new FormControl(null, Validators.required),
      subject_id: new FormControl("0"),
      peyvast: new FormControl("1"),
      takhfif: new FormControl("0"),
      sex: new FormControl("1", Validators.required),
      arsh_afzoodeh: new FormControl("0"),
      bazgashtBeNamehShomareh: new FormControl(null, Validators.required),
      bazgashtBeNamehTarikh: new FormControl(null, Validators.required),
      pishPardakht: new FormControl("0"),
      pishPardakhtAlpah: new FormControl(""),
      textletter_id: new FormControl("0"),
    })

    this.DeviceForm = new FormGroup({
      id: new FormControl(),
      device_id: new FormControl("0", Validators.required),
      location: new FormControl("0", Validators.required),
      tedad: new FormControl(null, Validators.required),
      dsc: new FormControl(null),
      Expiration: new FormControl("0", Validators.required),
    })
  }

  OnInitail_Form() {
    this.LetterRequestCustomer_Service.GetSingle(this.Token, this.Letter_Form_Id).subscribe(
      data => {
        this.Data_Seleted_Customer = data['cusomter']
        this.UploadImageSrc_List = data['image']
        this.Letter_Form_Code = data['lettercode']

        this.DeviceFormList = data['device']
        this.Record_Letter = data['main']

        if (data['main']['sex'] == true)
          this.get_Form_sex().setValue('1')
        else
          this.get_Form_sex().setValue('0')

        this.get_Form_giver_name().setValue(this.Record_Letter.giver_name)
        this.get_Form_giver_semat().setValue(this.Record_Letter.giver_semat)
        this.get_Form_bazgashtBeNamehShomareh().setValue(this.Record_Letter.bazgashtBeNamehShomareh)
        this.get_Form_bazgashtBeNamehTarikh().setValue(data['bazgashtBeNamehTarikh'])


        this.pishPardakht_Change()

        this.Read_Order_Operation()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#region  Form Add

  AddNewLetter: FormGroup;

  get_Form_giver_name() {
    return this.AddNewLetter.get('giver_name') as FormControl;
  }
  get_Form_giver_semat() {
    return this.AddNewLetter.get('giver_semat') as FormControl;
  }
  get_Form_subject_id() {
    return this.AddNewLetter.get('subject_id') as FormControl;
  }
  get_Form_peyvast() {
    return this.AddNewLetter.get('peyvast') as FormControl;
  }
  get_Form_takhfif() {
    return this.AddNewLetter.get('takhfif') as FormControl;
  }
  get_Form_sex() {
    return this.AddNewLetter.get('sex') as FormControl;
  }
  get_Form_arsh_afzoodeh() {
    return this.AddNewLetter.get('arsh_afzoodeh') as FormControl;
  }
  get_Form_bazgashtBeNamehShomareh() {
    return this.AddNewLetter.get('bazgashtBeNamehShomareh') as FormControl;
  }
  get_Form_bazgashtBeNamehTarikh() {
    return this.AddNewLetter.get('bazgashtBeNamehTarikh') as FormControl;
  }
  get_Form_pishPardakht() {
    return this.AddNewLetter.get('pishPardakht') as FormControl;
  }

  get_Form_pishPardakhtAlpah() {
    return this.AddNewLetter.get('pishPardakhtAlpah') as FormControl;
  }

  get_Form_textletter_id() {
    return this.AddNewLetter.get('textletter_id') as FormControl;
  }

  pishPardakht_Change() {
    this.Price_Service.GetPriceAlphabet(this.get_Form_pishPardakht().value).subscribe(
      data => {
        this.get_Form_pishPardakhtAlpah().setValue(data['price'])
      }
    )
  }

  //#endregion


  //#region Device
  DeviceFormList: Array<LetterRequestCustomer_Device_Interface> = []
  DeviceForm: FormGroup;
  DeviceFormListPriceTotal: number = 0
  DeviceFormListTakhfifTotal: number = 0
  DeviceFormListarsh_afzoodehTotal: number = 0


  get_DeviceForm_id() {
    return this.DeviceForm.get('id') as FormControl;
  }

  get_DeviceForm_device_id() {
    return this.DeviceForm.get('device_id') as FormControl;
  }

  get_DeviceForm_location() {
    return this.DeviceForm.get('location') as FormControl;
  }

  get_DeviceForm_tedad() {
    return this.DeviceForm.get('tedad') as FormControl;
  }

  get_DeviceForm_dsc() {
    return this.DeviceForm.get('dsc') as FormControl;
  }

  get_DeviceForm_Expiration() {
    return this.DeviceForm.get('Expiration') as FormControl;
  }

  DeviceForm_Submit() {

    if (this.get_DeviceForm_location().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the calibration location.")
    }
    else if (this.selected_Tariff_Record.id == 0) {
      this.Alertify_Service.ErrorMessage("Select a note.")
    }
    else if (this.get_DeviceForm_device_id().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the Persian title.")
    }
    else if (this.get_DeviceForm_Expiration().value == "0") {
      this.Alertify_Service.ErrorMessage("Select the validity period.")
    }
    else {
      var temp: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface()
      temp.device_id = Number(this.get_DeviceForm_device_id().value)
      temp.device_name = this.Find_DataList_Devicepersian_Title(this.get_DeviceForm_device_id().value)

      if (this.get_DeviceForm_location().value == "1") {
        temp.location_id = 1
        temp.location_name = 'محل مشتری'
      }
      else {
        temp.location_id = 0
        temp.location_name = 'آزمایشگاه بهینه'
      }

      temp.tedad = Number(this.get_DeviceForm_tedad().value)
      temp.expiration = Number(this.get_DeviceForm_Expiration().value)
      temp.expiration_title = this.Find_Expiration_Title(Number(this.get_DeviceForm_Expiration().value))

      temp.dsc = this.get_DeviceForm_dsc().value
      temp.price_dsc = this.selected_Tariff_Record.dsc
      temp.price = this.selected_Tariff_Record.tariff
      temp.price_id = this.selected_Tariff_Record.id
      temp.device_name_en = this.Data_Seleted_Device_Record.title
      temp.del = false
      this.get_DeviceForm_dsc().setValue("")


      this.DeviceFormList.push(temp)
    }

  }

  Find_DataList_Devicepersian_Title(id) {
    for (let item of this.DataList_Devicepersian) {
      if (item.id == id) {
        return item.dsc
      }
    }
  }

  Find_DataList_Tariff_Title(id): Tariff_Interface {
    for (let item of this.DataList_Tariff) {
      if (item.id == id) {
        return item
      }
    }
  }

  DeleteDeviceFormList_Index: number = -1;
  DeleteDeviceFormList_Record: LetterRequestCustomer_Device_Interface = Empty_LetterRequestCustomer_Device_Interface();

  modalRef_DeleteDeviceFormList:any
  DeleteDeviceFormList_Modal(template: TemplateRef<any>,id:number) {
    this.DeleteDeviceFormList_Index = id
    this.DeleteDeviceFormList_Record = this.DeviceFormList[this.DeleteDeviceFormList_Index]
    this.modalRef_DeleteDeviceFormList = this.modalService.show(template);
  }

  DeleteDeviceFormList() {

    if (this.DeleteDeviceFormList_Record.id == 0)
    {
      this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
      this.Alertify_Service.SuccessMessage(" Deleted successfully.")
      this.modalRef_DeleteDeviceFormList.hide()
    }
    else {
      this.InProccessing=true
      this.LetterRequestCustomer_Service.DeleteDevice(this.Token, this.DeleteDeviceFormList_Record.id).subscribe(
        data => {
          this.InProccessing = false
          this.DeviceFormList.splice(this.DeleteDeviceFormList_Index, 1)
          this.Alertify_Service.SuccessMessage(" Deleted successfully.")
          this.modalRef_DeleteDeviceFormList.hide()
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }


  //#endregion

  //#region Instrument

  modalRef_Device: any;

  ProcssingDevice: boolean = false

  Search_Name_Device_Table: string = ''
  Search_Code_Device_Table: string = ''

  openModal_Device(template: TemplateRef<any>) {
    this.modalRef_Device = this.modalService.show(template);
  }

  DataList_Device: Array<Device_Interface> = []
  Data_Seleted_Device_Record: Device_Interface = Empty_Device_Interface()

  ReadData_Device_KeySearch_Timer: any
  ReadData_Device_KeySearch() {

    if (this.ReadData_Device_KeySearch_Timer) {
      clearTimeout(this.ReadData_Device_KeySearch_Timer);
      this.ReadData_Device_KeySearch_Timer = null;
    }

    this.ReadData_Device_KeySearch_Timer = setTimeout(function () {
      this.ReadData_Device()
    }.bind(this), 1000);

  }

  ReadData_Device() {
    if (!this.Search_Name_Device_Table) {
      this.DataList_Device = []
    }
    else {
      this.ProcssingDevice = true
      this.Device_Service.GetSearchCalibration(this.Token, this.Search_Name_Device_Table, this.Search_Code_Device_Table).subscribe(
        data => {
          this.DataList_Device = data
          this.ProcssingDevice = false
        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }
  }

  Set_Selected_Device_Record(item) {
    this.Data_Seleted_Device_Record = item
    this.modalRef_Device.hide()
    this.ReadData_Devicepersian()
  }

  //#endregion

  //#region Devicepersian

  DataList_Devicepersian: Array<Devicepersian_Interface> = []

  ReadData_Devicepersian() {
    this.Devicepersian_Service.GetDevicePersian(this.Token, this.Data_Seleted_Device_Record.id).subscribe(
      data => {

        this.DataList_Devicepersian = data
        this.get_DeviceForm_device_id().setValue("0")
        this.ReadData_Tariff()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion

  //#region Tariff

  selected_Tariff_Record: Tariff_Interface = Empty_Tariff_Interface()
  DataList_Tariff: Array<Tariff_Interface> = []
  ReadData_Tariff() {
    this.Tariff_Service.GetDeviceTariff(this.Token, this.Data_Seleted_Device_Record.id,0).subscribe(
      data => {
        this.DataList_Tariff = data
        this.selected_Tariff_Record = Empty_Tariff_Interface()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  set_Selected_Tariff(item: Tariff_Interface) {
    this.selected_Tariff_Record = item
  }

  //#endregion

  //#region Customer

  Data_Seleted_Customer: Customer_List_Interface = Empty_Customer_List_Interface()

  //#endregion

  //#region Letter Order

  Data_List_Order: Array<LetterRequestCustomer_Order_Interface>=[]
  Read_Order_Operation() {
    this.Data_List_Order = []
    this.LetterRequestCustomer_Service.GetOperation(Number(this.Letter_Form_Id), 0, false, false, true, this.Token).subscribe(
      data => {

        this.Data_List_Order = data['result']
        this.canEditMainForm = data['canEditMainForm']
        this.parentRefer = data['parentRefer']
        this.Read_Expiration()
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  Selected_Order_Operation: LetterRequestCustomer_Order_Interface = Empty_LetterRequestCustomer_Order_Interface()
  LetterHistoryDsc: string = ''
  modalRef_Order: any;
  Data_list_LetterRole: Array<General_Interface> = []
  OpenOrderDialog_Loading:boolean=false
  OpenOrderDialog(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {
    this.Data_list_LetterRole = []
    this.LetterHistoryDsc = ''
    this.Selected_Order_Operation = item
    this.OpenOrderDialog_Loading=true
    this.LetterRequestCustomer_Service.GetUserrole(item.id,item.role_id, this.Token).subscribe(
      data => {
        this.OpenOrderDialog_Loading=false
        this.Data_list_LetterRole = data
        this.modalRef_Order = this.modalService.show(template);
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  //#endregion


   //#region Image

   modalRef_Image: any;
   ModalimageUrl: string = ''
   openModal(template: TemplateRef<any>, imageUrl: string) {
     this.ModalimageUrl = imageUrl
     this.modalRef_Image = this.modalService.show(template);
   }

   BaseUrl = environment.BaseUrl
   UploadImageSrc_List: Array<General_Interface> = []
   UploadImageSrc: string = ''
   InProccessing_Image1: boolean = false
   uploadImage1(files) {
     if (files.length === 0)
       return;

     const formData = new FormData();

     for (const file of files) {
       formData.append(file.name, file);
     }

     this.InProccessing_Image1 = true

     this.LetterRequestCustomer_Service.uploadFile(formData,this.Token).subscribe(
       data => {
         this.InProccessing_Image1 = false
         if (data['id'] == 0) {
           this.Alertify_Service.ErrorMessage(data['filename'])
         }
         else {
           this.Alertify_Service.SuccessMessage("The file was uploaded successfully.")
           this.UploadImageSrc = data['filename']
         }
       }
     )

   }

   Remove_uploadImage1() {
     this.UploadImageSrc = ''
   }

   Add_uploadImage1() {
    var temp:General_Interface=Empty_General_Interface()
    temp.title = this.UploadImageSrc

     this.UploadImageSrc_List.push(temp)
     this.UploadImageSrc = ''
     this.Alertify_Service.SuccessMessage("Added to the table.")
   }

   UploadImageSrc_List_Delete(id: number) {
     this.UploadImageSrc_List.splice(id, 1)
     this.Alertify_Service.SuccessMessage("Deleted successfully.")
   }

   //#endregion

  //#region Validity Period

  Data_List_Expiration: Array<FeildActivity_Interface> = []
  Read_Expiration() {
    this.Expiration_Service.GetActive(this.Token).subscribe(
      data => {
        this.Data_List_Expiration = data

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  Find_Expiration_Title(id) {
    for (let item of this.Data_List_Expiration) {
      if (item.id == id) {
        return item.title
      }
    }
    return ''
  }

  //#endregion


  
  //#region History

  Show_History_View: number = 0
  DataList_History: Array<LetterRequestCustomer_History_Interface> = []
  ReadHistory_Letter() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.GetHistory(Number(this.Letter_Form_Id), this.Token).subscribe(
      data => {
        this.InProccessing = false
        this.Show_History_View = 1
        this.DataList_History = data
      }
    )
  }

  DeleteLetterHistoryRecord() {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.DeleteLetterHistoryRecord(Number(this.Letter_Form_Id), this.Token).subscribe(
      data => {
        this.InProccessing = false
        if (data['id'] == 1) {
          this.ReadHistory_Letter()
        }
        else {
          this.Alertify_Service.ErrorMessage("Deletion is not permitted.")
        }

      }
    )
  }
  Close_Show_History() {
    this.Show_History_View = 0
  }

  //#endregion




  Letter_Form_Code: String = ''
  modalRef_Code: any;

  InProccessing: boolean = false
  SubmitAddNewLetter(template: TemplateRef<any>, GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {

    var DeviceFormList_Temp: Array<LetterRequestCustomer_Device_Interface> = []
    for (let item of this.DeviceFormList) {
      if (item.del == false) {
        DeviceFormList_Temp.push(item)
      }
    }


    if (DeviceFormList_Temp.length == 0) {
      this.Alertify_Service.ErrorMessage("Add at least one item of equipment.")
    }
    else {
      var tempAddress: Address_Interface = Empty_Address_Interface()


      var temp: Letter_Interface = Empty_Letter_Interface()
      temp.id = Number(this.Letter_Form_Id)
      temp.giver_name = this.get_Form_giver_name().value
      temp.giver_semat = this.get_Form_giver_semat().value
      temp.bazgashtBeNamehShomareh = this.get_Form_bazgashtBeNamehShomareh().value
      temp.sex = (this.get_Form_sex().value == "1")


      this.InProccessing = true
      this.LetterRequestCustomer_Service.AddEditLetterRequestCustomer(
        temp,
        this.get_Form_bazgashtBeNamehTarikh().value,
        this.Data_Seleted_Customer,
        tempAddress,
        DeviceFormList_Temp,
        [],
        [],
        [],
        [],
        this.UploadImageSrc_List,
        false,
        false,
        true,
        0,
        false,
        GiverUser,
        Order.goSection,
        Order.id,
        this.LetterHistoryDsc,
        this.parentRefer,
        1,
        this.Token).subscribe(
          data => {
            this.Letter_Form_Code = data['giver_name']
            this.Letter_Form_Id = data['id']

            this.Read_Order_Operation()
            this.Alertify_Service.SuccessMessage("The information was saved successfully.")
            this.InProccessing = false
            this.modalRef_Code = this.modalService.show(template);
            this.OnInitail_Form();
          }
        )
    }
  }

  SubmitActionLetter(GiverUser: number, Order: LetterRequestCustomer_Order_Interface) {
    this.InProccessing = true
    this.LetterRequestCustomer_Service.SubmitActionLetter(
      this.Letter_Form_Id,
      GiverUser,
      Order.goSection,
      Order.id,
      this.LetterHistoryDsc,
      this.parentRefer,
      this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          this.InProccessing = false
          this.Read_Order_Operation()
        }
      )
  }

  SubmitAddNewLetter_Co(template: TemplateRef<any>, item: LetterRequestCustomer_Order_Interface) {

    if (item.submit) {
      this.modalRef_Order.hide()
      this.SubmitAddNewLetter(template, -2, item)
    }
    else if (item.hasRefer) {
      this.modalRef_Order.hide()
      this.SubmitActionLetter(-2, item)
    }
    else {
      this.modalRef_Order.hide()
      this.SubmitActionLetter(0, item)
    }
  }
}
